// hooks/Context.js
import { createContext } from "react";

export const toolsContext = createContext([]);
